<div style="margin: 0; padding: 0.2em">
  <p class="field_title">{{title}}</p>
  <p class="field_value" #ref><ng-content></ng-content></p>
  <p class="field_value" *ngIf="ref.children.length == 0">-</p>
</div>
